import { selectIsLoggedIn } from 'modules/auth';
import { useSelector } from 'react-redux';
import { useGetMyOrganizationsQuery } from 'store/api/organizations';
import { Organization } from 'store/api/types';

export const useLimits = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn());

  const {
    data: myOrganizations,
    isLoading,
    isFetching,
    isUninitialized,
    refetch,
  } = useGetMyOrganizationsQuery(undefined, { skip: !isLoggedIn });

  const currentOrganization: Organization | undefined = myOrganizations?.[0];
  const hasOrganization = Boolean(currentOrganization?.id);
  // isFetching must not flip this flag — otherwise the app remounts and
  // refetch loops (UserRestricted ↔ /contracts) with no organization context.
  const isLimitedUser = Boolean(
    isLoggedIn && !isLoading && !isUninitialized && !hasOrganization,
  );

  return {
    isLimitedUser,
    hasOrganization,
    isFetching,
    isLoading: !isLoggedIn ? false : isLoading || isUninitialized,
    refetch,
  };
};
